var path = '/static/assets/khapps/niabcuf/irrigation/partials/irrigation_summary_plot.html';
var html = "<div>\n    <highchart id=\"irrigationSummaryView\" config=\"irrigationSummaryViewConfig\"></highchart>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;